import { ShortDriver } from '@allocab/allocab-driver-shared-types';
import { useState } from 'react';

import { VehicleAssignModal } from './VehicleAssignModal';
import { t } from '../../services/translation/translation';
import { PrimaryButton } from '../button/PrimaryButton';

type Props = {
  drivers: ShortDriver[];
  vehicleId: string;
  isDisabled?: boolean;
};

export const VehicleAssignButton = ({ drivers, vehicleId, isDisabled }: Props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <PrimaryButton
        text={t('common.assign')}
        onClick={() => setIsModalVisible(true)}
        isDisabled={isDisabled}
        title={isDisabled ? t('vehicle-assign.not-allowed') : undefined}
      />
      {isModalVisible ? (
        <VehicleAssignModal onClose={() => setIsModalVisible(false)} drivers={drivers} vehicleId={vehicleId} />
      ) : null}
    </>
  );
};
